import React, { useEffect, useState } from "react";
import ProductList from "../../components/DynamicList&Grid/DynamicListGrid";
import { getStoredData } from "../../json/fecthData";
import axios from "axios";
import "./VendorManagement.css";

const VendorManagement = () => {
  const userData = getStoredData()?.[1] || {};

  const { TitleUser, AdminUser, RedirectAdminUser, ApiUser } = userData;

  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Static role ID used for vendors
  const vendorRoleId = "67fcd2167d4f2741c40380a7";

  useEffect(() => {
    const fetchVendorsByRole = async () => {
      try {
        const res = await axios.get(
          `https://hammontrackingbackend-3.onrender.com//user/role/${vendorRoleId}`
        );
        setUser(res.data || []);
      } catch (err) {
        console.error("Error fetching vendors:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchVendorsByRole();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="UserManagement">
      <h1>{TitleUser} Management</h1>

      {AdminUser && user.length > 0 ? (
        <ProductList
          products={user}
          fields={AdminUser}
          redirect={RedirectAdminUser}
          deleteApi={ApiUser}
          showEdit={true}
          showDelete={true}
          createPath={`/${TitleUser?.toLowerCase()}/create`}
        />
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default VendorManagement;
